import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import asyncComponent from "util/asyncComponent";


const SocialApps = ({ match }) => (
  <Switch>
    <Route path={`${match.url}/profile`} component={asyncComponent(() => import('./Profile'))} />
  </Switch>
);

export default SocialApps;
